import API from '../../../../common/http/api.fetch';
// import I18N from '../../../../common/utils/util.i18n';
import {success, responseMessage, info} from '../../../../common/utils/util.notifier';
import { GRID_FETCH, GRID_RELOAD, GRID_FILTER, GRID_SELECT_ALL } from '../../../../common/grid/grid.constants';
import { TYPES as ACC_TYPES } from '../../accreditation-action-type.constants';
import { IDS } from '../settings-action-id.constants';
import { getDocFileNameFromPath } from "../../../../common/utils/util.path";
import truncate from 'lodash/truncate';
import {TAB_SELECT} from "../../../../common/tabs/tabs.constants";

// const localizeType = (code, defaultName) => {
//     const textId = `DOCUMENT_MANAGEMENT.TYPES.${code.toUpperCase()}`;
//     const translation = I18N.translate(textId);
//     return translation === textId ? defaultName : translation
// };

export const fetchSettingsEvidenceGroups = (filter) => {
    if(!filter.scheme_code)
        return dispatch => {};

    return dispatch => {
        return API.fetch({
            url:    '/rco/list-evidence-groups-grid',
            method: 'GET',
            params: {
                ...filter,
                scope_subject_types: 'cla,hof',
                path: undefined
            }
        }).then(({data}) => {

            // parse json string to array of objects
            const items = data.items.map( item => ({
                ...item,
                requirements: JSON.parse(item.requirements)
            }));

            dispatch({
                type:   GRID_FETCH,
                id:     IDS.accSettings,
                path:   filter.path,
                ...data,
                items: items.map( item => ({
                    ...item,
                    type: item.type_name,
                    filename: getDocFileNameFromPath(item.doc_uri),
                    requirements: item.requirements.map(requirement => requirement.name).join(),
                    requirementsColumn: truncate(item.requirements.map(doc => doc.name).join(),{ 'length': 50}),
                    sampleDocFilename: getDocFileNameFromPath(item.sample_doc_uri),
                }))
            })
        }, error => {
            responseMessage(error);
        });
    };
}

export const importEvidenceGroupsFile = (file_path, scheme_code) => {
    return dispatch => {
        return API.fetch({
            url: `/rco/import-evidence-groups`,
            method: 'POST',
            data: {
                scheme_code,
                file_path,
            },
        }).then(response => {
            success('COMMON.SERVER_RESPONSE.IMPORT_SUCCESSFUL');
        },error => {
            responseMessage(error)
        });
    };
}

export const exportEvidenceGroupsFile = (filter, downloadFile) => {
    if(!filter.scheme_code) {
        return dispatch => {};
    }

    info('Please wait...', false);
    return dispatch => {
        return API.fetch({
            url:    '/rco/export-evidence-groups',
            method: 'GET',
            params: {
                ...filter,
                scope_subject_types: 'cla,hof',
                limit: undefined,
                offset: undefined,
                path: undefined
            }
        }).then(({data}) => {
            downloadFile('/' + data.path)
            success('Export Complete!');
        }, error => {
            responseMessage(error);
        });
    };
}

export const addHeadOfficeEvidenceGroup = (data) => {
    return dispatch => {
        return API.fetch({
            url: '/rco/add-evidence-group',
            method: 'POST',
            data
        }).then(response => {
            success('COMMON.SERVER_RESPONSE.ITEM_ADDED');
            dispatch({
                type: GRID_RELOAD,
                id: IDS.accSettings,
                path: IDS.evidenceGrid,
            });
            dispatch({
                type: TAB_SELECT,
                id: IDS.app_accreditation_scheme_settings_evidence,
                state: IDS.app_accreditation_scheme_settings_evidence_list,
            });
        }, error => {
            responseMessage(error);
        });
    };
}

export const editHofEvidenceGroup = (data) => {
    return dispatch => {
        return API.fetch({
            url: '/rco/edit-hof-evidence-group',
            method: 'POST',
            data,
        }).then(response => {
            dispatch({
                type:   GRID_RELOAD,
                id:     IDS.accSettings,
                path:   IDS.evidenceGrid,
            })
            success('COMMON.SERVER_RESPONSE.ITEM_UPDATED');
        }, error => {
            responseMessage(error);
        });
    };
}

export const fetchEvidenceApplicableHeadOfficesGrid = (filter) => {
    return dispatch => {
        return API.fetch({
            url:    '/rco/list-evidence-applicable-head-offices',
            method: 'GET',
            params: {
                ...filter,
                path: undefined,
                newAssessmentHeadOffices: undefined,
            }
        }).then(({data}) => {
            data.forEach( item => {
                item.id = item.uuid;
            });
            dispatch({
                type:   GRID_FETCH,
                id:     IDS.accSettings,
                path:   filter.path,
                items: data
            });
            // feed data in to checkboxes
            dispatch({
                type:   GRID_SELECT_ALL,
                id:     IDS.accSettings,
                path:   filter.path,
                data:   data.filter( item => item.applicable === 1).map( item => item.uuid)
            });
        }, error => {
            responseMessage(error);
        });
    };
}

export const fetchEvidenceApplicableSitesGrid = (filter) => {
    return dispatch => {
        return API.fetch({
            url:    '/rco/list-evidence-applicable-sites',
            method: 'GET',
            params: {
                ...filter,
                path: undefined,
                newAssessmentHeadOffices: undefined
            }
        }).then(({data}) => {
            dispatch({
                type:   GRID_FETCH,
                id:     IDS.accSettings,
                path:   filter.path,
                ...data
            });
            dispatch({
                type:   GRID_SELECT_ALL,
                id:     IDS.accSettings,
                path:   filter.path,
                data:   data.items.filter( item => item.applicable === 1).map( item => item.uuid)
            });
        }, error => {
            responseMessage(error);
        });
    };
}

export const fetchSiteLocationDetails = (siteLocationUuid) => {
    return dispatch => {
        return API.fetch({
            url: `/location/sitelocation/${siteLocationUuid}`,
            method: 'GET',
            params: {}
        }).then(response => {
            return response.data[0][0];
        })
    }
}

export const fetchEnabledHeadOffices = (schemeId) => {
    return dispatch => {
        return API.fetch({
            url: '/rco/regulatory-framework-locations',
            method: 'GET',
            params: {
                asc_id: schemeId
            }
        }).then(({data}) => {
            dispatch({
                type: ACC_TYPES.FETCH_SCHEME_ENABLED_HEAD_OFFICES,
                id: IDS.evidence,
                items: data.items.map( item => ({
                        value: item.slo_uuid,
                        label: item.slo_name,
                }))
            });
            return data.items;
        })
    }
}

export const fetchHofRequiredDocsImportsGrid = (filter) => {
    return dispatch => {
        return API.fetch({
            url:    '/rco/list-evidence-groups-imports-grid',
            method: 'GET',
            params: {
                ...filter,
                path: undefined,
            }
        }).then(({data}) => {
            dispatch({
                type:   GRID_FETCH,
                id:     IDS.accSettings,
                path:   filter.path,
                ...data,
                items: data.items.map( item => ({...item, dateTime: true})),
            })
        }, error => {
            responseMessage(error);
        })
    }
}